export default __webpack_public_path__ + "static/media/intradel.9204041a.jpg";